import ACTIONS from "./actionTypes"

export const setIfCanProceed = canProceed => ({
  type: ACTIONS.IF_CAN_PROCEED,
  canProceed,
})
